import { render, staticRenderFns } from "./inventoryManagement.vue?vue&type=template&id=85af1d42&scoped=true&"
import script from "./inventoryManagement.vue?vue&type=script&lang=js&"
export * from "./inventoryManagement.vue?vue&type=script&lang=js&"
import style0 from "./inventoryManagement.vue?vue&type=style&index=0&id=85af1d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85af1d42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85af1d42')) {
      api.createRecord('85af1d42', component.options)
    } else {
      api.reload('85af1d42', component.options)
    }
    module.hot.accept("./inventoryManagement.vue?vue&type=template&id=85af1d42&scoped=true&", function () {
      api.rerender('85af1d42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryManagement.vue"
export default component.exports